import PageTitle from '../../components/UI/PageTitle/PageTitle';
import React, { useEffect, useMemo, useState } from 'react';
import { format } from 'date-fns/esm';
import { parseISO } from 'date-fns';
import { toast } from 'react-toastify';
import POSITION = toast.POSITION;
import classes from './Orders.module.css';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { ICustomer, fetchCustomers, selectCustomers } from '../../store/slices/customers';
import {
  IProductDetail,
  IProductCategory,
  selectProductCategories,
  fetchProductCategories,
  selectProductDetails,
} from '../../store/slices/productCategories';
import {
  selectPaymentMethods,
  selectAccountInfo,
  IAccountInfo,
  getTimeSlots,
  selectUserRole,
  IDirtyState,
  selectDirtyState,
  setDirtyState,
} from '../../store/slices/auth';
import {
  ISalesOrderProduct,
  fetchSalesOrderProducts,
  selectSalesOrderProducts,
} from '../../store/slices/salesOrderProducts';
import { deleteCart, ICartProduct, selectCart } from '../../store/slices/cart';
import SelectCustomerModal from './Modals/SelectCustomerModal';
import PayInvoiceModal from './Modals/PayInvoiceModal';
import { authorizeClient, client } from '../../networking/client';
import QrCodeModal from '../../components/UI/Modals/QrCodeModal';

import PrimaryButtonV2 from '../../components/UI/Buttons/PrimaryButtonV2';
import { ReportsTableHeader } from '../../components/Headers/ReportsTableHeader';
import { ReportTable } from '../../components/UI/Layouts/ReportTable';
import { Cart } from './Cart';
import { Products } from './Products';
import ConfirmPaymentModal from './Modals/ConfirmPaymentModal';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import { Stepper } from '../../components/UI/Stepper/Stepper';
import { OrderSummaryModal } from './Modals/OrderSummaryModal';
import { DataTable } from '../../components/DataTable/DataTable';
import {
  getAccountNumberFromEbaasPersonAccounts,
  IMappedProductDetail,
  IMappedSalesOrder,
  salesOrderRecordStateToStatus,
  transformSalesOrders,
} from '../../utils/miscUtils';
import { NURSE_USER_ROLE } from '../../constants/userRolesConstants';
import { AddCustomer } from '../Customers/AddCustomer';
import {
  SalesOrderInfo,
  fetchSalesOrders,
  selectSalesOrders,
} from '../../store/slices/salesOrders';
import {
  HOMECARE_DIAGNOSTICS_SERVICE_GROUP_ID,
  PHARMACY_DIAGNOSTICS_SERVICE_GROUP_ID,
} from '../../constants/serviceGroupConstants';
import leftArrow from './../../assets/icons/backIcon.svg';
import { CustomerView } from '../Customers/CustomerView';
import CustomPagination from '../../components/UI/CustomPagination/CustomPagination';
import { useTranslation } from '../../hooks/useTranslations';

const Order: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const [searchedCustomer, setSearchedCustomer] = useState<ICustomer>();
  const [selectedCustomer, setSelectedCustomer] = useState<ICustomer>();
  const [activeStep, setActiveStep] = React.useState<number>(1);
  const [isAddingOrder, setIsAddingOrder] = useState<boolean>(false);
  const customers: ICustomer[] = useAppSelector<ICustomer[]>(selectCustomers);
  const paymentMethods: string[] = useAppSelector<string[]>(selectPaymentMethods);
  const accountInfo: IAccountInfo = useAppSelector<IAccountInfo>(selectAccountInfo);
  const userRole = useAppSelector<string>(selectUserRole);
  const salesOrderProducts: ISalesOrderProduct[] =
    useAppSelector<ISalesOrderProduct[]>(selectSalesOrderProducts);
  const [isSelectCustomerModalOpen, setIsSelectCustomerModalOpen] = useState<boolean>(false);
  const [isPayInvoiceModalOpen, setIsPayInvoiceModalOpen] = useState<boolean>(false);
  const carts = useAppSelector<ICartProduct[]>(selectCart);
  const [displayOrders, setDisplayOrders] = useState<ISalesOrderProduct[]>([]);
  const [salesOrderIdSearch] = useState<string>('');
  const [externalSalesIdSearch] = useState<string>('');
  const [customerFirstNameSearch, setCustomerFirstNameSearch] = useState<string>('');
  const [customerLastNameSearch] = useState<string>('');
  const [amountSearch] = useState<string>('');
  const [vatSearch] = useState<string>('');
  const [currencySearch] = useState<string>('');
  const [createdAtSearch] = useState<string>('');
  const [paymentMethodSearch] = useState<string>('');
  const [paidSearch] = useState<string>('');
  const [isScanningQrCode, setIsScanningQrCode] = useState<boolean>(false);
  const [isSpinnerActive, setIsSpinnerActive] = useState<boolean>(false);
  const [isConfirmPaymentModalOpen, setIsConfirmPaymentModalOpen] = useState<boolean>(false);
  const [displayCustomers, setDisplayCustomers] = useState<ICustomer[]>([]);
  const [selectedOrder, setSelectedOrder] = useState<ISalesOrderProduct | undefined>();

  const productCategories: IProductCategory[] =
    useAppSelector<IProductCategory[]>(selectProductCategories);
  const allSalesOrders = useAppSelector<SalesOrderInfo[]>(selectSalesOrders);
  const productDetails: IProductDetail[] = useAppSelector<IProductDetail[]>(selectProductDetails);

  const [startDateValue, setStartDateValue] = useState<Date | undefined>();
  const [endDateValue, setEndDateValue] = useState<Date | undefined>();
  const [hasSearchedWithDate] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [customerModal, setCustomerModal] = useState<ICustomer>();
  const [nameSearch, setNameSearch] = useState<string>('');
  const [showOrderSummaryModal, setShowOrderSummaryModal] = useState<boolean>(false);
  const [expandedRows, setExpandedRows] = React.useState<number[]>([]);
  const [transformedOrders, setTransformedOrders] = useState<IMappedSalesOrder[]>([]);
  const [bookingSortOrder, setBookingSortOrder] = useState<'asc' | 'desc' | null>("desc");
  const [orderSummaryCartItems, setOrderSummaryCartItems] = useState<
    {
      name: string;
      quantity: number;
      vat: number;
      total: number;
      hasWorkOrder?: boolean;
      isDiagnostic?: boolean;
      accountNumber?: string;
      salesOrderId?: number | string;
      salesOrderItemId?: number | string;
      salesOrderExternalId?: number | string;
    }[]
  >();
  const removeQueryParams = () => {
    const param = searchParams.get('person_id');
    if (param) {
      searchParams.delete('person_id');
      setSearchParams(searchParams);
    }
  };
  const totalSum = useMemo(() => {
    return carts.reduce((sum, product) => sum + (product.product.price || 0) * product.quantity, 0);
  }, [carts]);

  useEffect(() => {
    if (accountInfo.account_number) {
      dispatch(fetchCustomers());
      dispatch(fetchSalesOrders());
      dispatch(fetchSalesOrderProducts());
      dispatch(
        fetchProductCategories({
          productCategoryId: Number(process.env.REACT_APP_CATEGORY_ID),
          merchantAccountNumber: accountInfo.account_number,
        })
      );
      dispatch(getTimeSlots());
    }
  }, [dispatch, accountInfo.account_number]);

  useEffect(() => {
    setDisplayOrders([...salesOrderProducts]);
  }, [salesOrderProducts]);

  useEffect(() => {
    const addAccountNumberToSelectedCustomer = async (customer: ICustomer) => {
      // adding 3 seconds delay because account number isn't created immediately after user is registered
      await new Promise((resp) => setTimeout(resp, 3000));
      const ebaasPersonInfo = await client.get(
        `/core/person/accounts/${customer?.person_external_id}`
      );
      const accountNumberFetched = getAccountNumberFromEbaasPersonAccounts(ebaasPersonInfo);
      const response = await client.put(
        `/healthpoint/person/accountNumber/${customer?.person_external_id}/${accountNumberFetched}`
      );
      if (response.data?.person) {
        setSelectedCustomer({
          ...customer,
          person_account_number: response.data?.person.person_account_number,
        });
      }
    };
    if (selectedCustomer && !selectedCustomer.person_account_number) {
      addAccountNumberToSelectedCustomer(selectedCustomer);
    }
  }, [selectedCustomer]);

  useEffect(() => {
    let tempoOrders = [...salesOrderProducts];
    if (salesOrderIdSearch.trim().length > 0)
      tempoOrders = tempoOrders.filter((salesOrderProduct) =>
        salesOrderProduct.sales_order_id
          ?.toString()
          .toLowerCase()
          .includes(salesOrderIdSearch.toLocaleLowerCase())
      );
    if (externalSalesIdSearch.trim().length > 0)
      tempoOrders = tempoOrders.filter((salesOrderProduct) =>
        salesOrderProduct.sales_order_external_id
          ?.toString()
          .toLowerCase()
          .includes(externalSalesIdSearch.toLocaleLowerCase())
      );
    if (customerFirstNameSearch.trim().length > 0)
      tempoOrders = tempoOrders.filter(
        (salesOrderProduct) =>
          salesOrderProduct.person_firstname
            .toLowerCase()
            .includes(customerFirstNameSearch.toLocaleLowerCase()) ||
          salesOrderProduct.person_lastname
            .toLowerCase()
            .includes(customerFirstNameSearch.toLocaleLowerCase())
      );
    if (customerLastNameSearch.trim().length > 0)
      tempoOrders = tempoOrders.filter((salesOrderProduct) =>
        salesOrderProduct.person_lastname
          .toLowerCase()
          .includes(customerLastNameSearch.toLocaleLowerCase())
      );
    if (amountSearch.trim().length > 0)
      tempoOrders = tempoOrders.filter((salesOrderProduct) =>
        salesOrderProduct.amount_paid
          ?.toString()
          .toLowerCase()
          .includes(amountSearch.toLocaleLowerCase())
      );
    if (vatSearch.trim().length > 0)
      tempoOrders = tempoOrders.filter((salesOrderProduct) =>
        salesOrderProduct.vat?.toString().toLowerCase().includes(vatSearch.toLocaleLowerCase())
      );
    if (currencySearch.trim().length > 0)
      tempoOrders = tempoOrders.filter((salesOrderProduct) =>
        salesOrderProduct.currency
          ?.toString()
          .toLowerCase()
          .includes(currencySearch.toLocaleLowerCase())
      );
    if (createdAtSearch.trim().length > 0)
      tempoOrders = tempoOrders.filter((salesOrderProduct) =>
        format(
          parseISO(salesOrderProduct.datetime_create?.toString() ?? '2000-01-01'),
          'dd.MM.yyyy; HH:mm'
        )
          .toLowerCase()
          .includes(createdAtSearch.toLocaleLowerCase())
      );

    if (paymentMethodSearch.trim().length > 0)
      tempoOrders = tempoOrders.filter((salesOrderProduct) =>
        salesOrderProduct.payment_method
          ?.toString()
          .toLowerCase()
          .includes(paymentMethodSearch.toLocaleLowerCase())
      );
    if (paidSearch.trim().length > 0)
      tempoOrders = tempoOrders.filter((salesOrderProduct) =>
        salesOrderProduct.paid?.toString().toLowerCase().includes(paidSearch.toLocaleLowerCase())
      );

    setDisplayOrders([...tempoOrders]);
    setTransformedOrders(transformSalesOrders([...tempoOrders]));
  }, [
    salesOrderIdSearch,
    externalSalesIdSearch,
    customerFirstNameSearch,
    customerLastNameSearch,
    amountSearch,
    vatSearch,
    currencySearch,
    createdAtSearch,
    hasSearchedWithDate,
    startDateValue,
    endDateValue,
    paidSearch,
    paymentMethodSearch,
    salesOrderProducts,
  ]);

  useEffect(() => {
    let tempoCustomers = [...customers];
    if (nameSearch.trim().length > 0)
      tempoCustomers = tempoCustomers.filter(
        (customer) =>
          customer.person_firstname.toLowerCase().includes(nameSearch.toLocaleLowerCase()) ||
          customer.person_lastname.toLowerCase().includes(nameSearch.toLocaleLowerCase())
      );
    setDisplayCustomers([...tempoCustomers]);
  }, [customers, nameSearch]);

  const onSaveSalesOrderProduct = async () => {
    if (!selectedCustomer || carts.length === 0) return;
    setIsSpinnerActive(true);
    if (paymentMethods.includes('hello_cash')) {
      toast.error(translations('placeholder.not_allowed'), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setIsSpinnerActive(false);
      // try {
      //   await client.post('/hellocash-payment', {
      //     customer: {
      //       firstName: selectedCustomer.person_firstname,
      //       lastName: selectedCustomer.person_lastname,
      //       email: selectedCustomer.person_email,
      //       phoneNumber: selectedCustomer.person_mobile_phone,
      //       birthday: selectedCustomer.person_birthdate,
      //       accountNumber: selectedCustomer.person_account_number,
      //     },
      //     product: {
      //       name: carts[0].product.product_name,
      //       price: `${((carts[0].product.product_price ?? 0) / 100).toFixed(2)} €`,
      //     },
      //   });
      //   setIsPayInvoiceModalOpen(true);
      //   setIsSpinnerActive(false);
      // } catch (err: any) {
      //   toast.error(err?.response?.data?.error ?? 'Something went wrong.', {
      //     position: toast.POSITION.BOTTOM_RIGHT,
      //   });
      //   setIsSpinnerActive(false);
      //   return;
      // }
    } else if (paymentMethods.includes('at_merchant')) {
      try {
        // await client.post(`/healthpoint/at-merchant-payment/${basicAuth}`, {
        //   customer: {
        //     firstName: selectedCustomer.person_firstname,
        //     lastName: selectedCustomer.person_lastname,
        //     email: selectedCustomer.person_email,
        //     phoneNumber: selectedCustomer.person_mobile_phone,
        //     birthday: selectedCustomer.person_birthdate,
        //     accountNumber: selectedCustomer.person_account_number,
        //   },
        //   language: carts[0].laboratoryLanguage ?? ['de'],
        //   productId: parseInt(carts[0].product.product_id.toString()),
        //   accountNumber: accountInfo.account_number,
        // appointmentStart: carts[0].appointmentStart
        //   ? new Date(carts[0].appointmentStart)?.toISOString()
        //   : undefined,
        // appointmentEnd: carts[0].appointmentEnd
        //   ? new Date(carts[0].appointmentEnd)?.toISOString()
        //   : undefined,
        //   isWithChatting:
        // carts[0].product.product_add_ons &&
        // carts[0].product.product_add_ons.find((addon) => addon.product_add_on_id == 1)
        //   ? true
        //   : false,
        //   isNurse: false,
        //   merchantPersonId: accountInfo.external_person_id,
        // });
        //check /location to see if customer already checked-in
        const locationResponse = await authorizeClient.get('/core/merchant/location');
        let dataNeeded: any;
        if (
          locationResponse.data &&
          locationResponse.data.find(
            (u: any) => u.account_number === selectedCustomer.person_account_number
          )
        ) {
          dataNeeded = locationResponse.data.find(
            (u: any) => u.account_number === selectedCustomer.person_account_number
          );
        } else {
          //check-in the customer
          await authorizeClient.put(
            `/core/merchant/location?merchant_account_number=${accountInfo.account_number}`,
            {
              customer_account: selectedCustomer.person_account_number,
              mobile_tag_id: 1,
            }
          );
          //check again the /location data after checkin
          const locationResponse2 = await authorizeClient.get('/core/merchant/location');
          if (
            locationResponse2.data &&
            locationResponse2.data.find(
              (u: any) => u.account_number === selectedCustomer.person_account_number
            )
          ) {
            dataNeeded = locationResponse2.data.find(
              (u: any) => u.account_number === selectedCustomer.person_account_number
            );
          }
        }
        let formData = new FormData();
        const formDataItems = {
          ta_id: dataNeeded.ta_id,
          location_id: dataNeeded.location_id,
          items: carts.map((cartItem) => {
            const appStart = cartItem.appointmentStart
              ? new Date(cartItem.appointmentStart)?.toISOString()
              : undefined;
            const appEnd = cartItem.appointmentEnd
              ? new Date(cartItem.appointmentEnd)?.toISOString()
              : undefined;
            return {
              product_id: parseInt(cartItem.product.product_id.toString()),
              languages: [localStorage.getItem('lang')?.toLowerCase()],
              quantity: 1,
              method_taken_id: 3,
              appointment:
                appStart && appEnd
                  ? {
                      start: appStart,
                      end: appEnd,
                    }
                  : undefined,
              with_chatting:
                cartItem.product.product_add_ons &&
                cartItem.product.product_add_ons.find((addon) => addon.product_add_on_id == 1)
                  ? true
                  : false,
            };
          }),
        };

        formData.append('location_data', JSON.stringify(formDataItems));
        await authorizeClient.post(
          `/core/merchant/${accountInfo.external_person_id}/order_product`,
          {
            ta_id: dataNeeded.ta_id,
            location_id: dataNeeded.location_id,
            items: carts.map((cartItem) => {
              const appStart = cartItem.appointmentStart
                ? new Date(cartItem.appointmentStart)?.toISOString()
                : undefined;
              const appEnd = cartItem.appointmentEnd
                ? new Date(cartItem.appointmentEnd)?.toISOString()
                : undefined;
              return {
                product_id: parseInt(cartItem.product.product_id.toString()),
                languages: [localStorage.getItem('lang')?.toLowerCase()],
                quantity: 1,
                method_taken_id: 3,
                appointment:
                  appStart && appEnd
                    ? {
                        start: appStart,
                        end: appEnd,
                      }
                    : undefined,
                with_chatting:
                  cartItem.product.product_add_ons &&
                  cartItem.product.product_add_ons.find((addon) => addon.product_add_on_id == 1)
                    ? true
                    : false,
              };
            }),
          }
        );
        //check /location
        const locationResponse2 = await authorizeClient.get('/core/merchant/location');
        let dataNeeded2: any;
        if (
          locationResponse2.data &&
          locationResponse2.data.find(
            (u: any) => u.account_number === selectedCustomer.person_account_number
          )
        ) {
          dataNeeded2 = locationResponse2.data.find(
            (u: any) => u.account_number === selectedCustomer.person_account_number
          );
        }
        if (totalSum !== 0) {
          if (dataNeeded2) {
            //create the sales-order
            await authorizeClient.post(
              userRole === NURSE_USER_ROLE
                ? `/core/merchant/product_order_payment/${accountInfo.external_person_id}?ta_id=${dataNeeded2.ref_ta_id}&transaction_id=${dataNeeded2.ref_transaction_id}&local_payment_method=cash`
                : `/core/merchant/product_order_payment?ta_id=${dataNeeded2.ref_ta_id}&transaction_id=${dataNeeded2.ref_transaction_id}&local_payment_method=cash`,
              {}
            );
          } else {
            throw new Error('Location Error');
          }
        }
        //check-out the customer
        await authorizeClient.delete(
          `/core/merchant/location?ta_id=${formDataItems.ta_id}&location_id=${formDataItems.location_id}`
        );
        toast.success(translations('placeholder.product_purchased'), {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        setIsConfirmPaymentModalOpen(false);
        setShowOrderSummaryModal(true);
        removeQueryParams();
      } catch (err: any) {
        console.log('err', err);
        toast.error(
          err?.response?.data
            ? translations(`error.${err.response.data.error_code}`)
            : translations('placeholder.something.went_wrong'),
          {
            position: toast.POSITION.BOTTOM_RIGHT,
          }
        );
        return;
      } finally {
        setIsSpinnerActive(false);
      }
    } else {
      toast.error(translations('placeholder.not_allowed'), {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      setIsSpinnerActive(false);
    }
  };

  const onScanCustomer = (accountNumber?: string) => {
    const tempoCustomer: ICustomer | undefined = customers.find(
      (c) => c.person_account_number == accountNumber
    );
    if (tempoCustomer) {
      setSearchedCustomer(tempoCustomer);
      setIsSelectCustomerModalOpen(true);
      return;
    }
    toast.error(translations('error.customer_notfound'), {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  };

  useEffect(() => {
    if (customers.length > 0) {
      const queryParameters = new URLSearchParams(window.location.search);
      const personId = queryParameters.get('person_id');
      if (personId) {
        const findPersonDetails: ICustomer | undefined = customers.find(
          (item) => item.person_id == Number(personId)
        );
        setIsAddingOrder(true);
        setSelectedCustomer(findPersonDetails);
      }
    }
  }, [customers]);

  const totalSteps = React.useMemo(() => {
    const stepsCount =
      carts.length > 0 &&
      carts[0].product?.product_group !== 'F' &&
      carts[0].product?.product_group !== 'C'
        ? 4
        : 3;
    if (carts.length === 0) {
      setActiveStep(1);
    } else {
      setActiveStep(stepsCount - 1);
    }
    return stepsCount;
  }, [carts]);

  const sortByBookingDate = (items: IMappedSalesOrder[], order: 'asc' | 'desc') => {
    return [...items].sort((a, b) => {
      const dateA = new Date(a.datetime_create).getTime();
      const dateB = new Date(b.datetime_create).getTime();

      if (order === 'asc') {
        return dateA - dateB;
      } else {
        return dateB - dateA;
      }
    });
  };

  const maxDate = useMemo(() => {
    const dates = salesOrderProducts
      .filter((salesOrder) => salesOrder.start)
      .map((salesOrder) => new Date(salesOrder.start ?? '').getTime());
    return new Date(Math.max.apply(null, dates.length > 0 ? dates : [new Date().getTime()]));
  }, [salesOrderProducts]);

  const sortedTransformedOrders = useMemo(() => {
    if (bookingSortOrder) {
      return sortByBookingDate(transformedOrders, bookingSortOrder);
    }
    return transformedOrders;
  }, [transformedOrders, bookingSortOrder]);

  const [isAddingPerson, setIsAddingPerson] = useState<boolean>(false);
  const isDirtyModal = useAppSelector<IDirtyState>(selectDirtyState);

  const handleBackButton = () => {
    if (!isDirtyModal.isDirty) {
      setIsAddingPerson(false);
      setSelectedCustomer(undefined);
    } else {
      dispatch(setDirtyState({ isDirty: true, isModalOpen: true }));
    }
  };

  const handleBookingDateSort = () => {
    if (bookingSortOrder === null || bookingSortOrder === 'desc') {
      setBookingSortOrder('asc');
      return 'asc';
    } else {
      setBookingSortOrder('desc');
      return 'desc';
    }
  };

  const getStatusClass = (status_id: string, missedAppointment: boolean) => {
    if (missedAppointment) {
      return classes.statusMissed;
    }
    if (status_id === 'closed') {
      return classes.statusCompleted;
    } else if (status_id === 'cancelled') {
      return classes.statusCancelled;
    } else if (status_id === 'open') {
      return classes.statusOpened;
    }
  };

  return (
    <div className={!isAddingPerson ? classes.container : ''}>
      <div className={!isAddingPerson ? classes.addOrderContainer : ''}>
        {isAddingOrder ? (
          ''
        ) : (
          <>
            <PageTitle className={classes.boldLabel}>{translations('orders')}</PageTitle>
            <PrimaryButtonV2
              text={translations('create.order')}
              containerStyle={{}}
              buttonStyle={{
                height: 44,
                borderRadius: 7,
                padding: '0 30px',
              }}
              disabled={false}
              onClick={() => {
                setIsAddingOrder(true);
                setActiveStep(0);
              }}
            />
          </>
        )}
      </div>

      {isAddingPerson ? (
        <div>
          <div className={classes.mainHeader}>
            <div className={classes.headerRegister}>
              <div className={classes.customerstext}>{translations('customers')}</div>
            </div>
            <div onClick={handleBackButton} className={classes.backHeader}>
              <img src={leftArrow} alt="leftArrow" />
              <div className={classes.backLabel}>{translations('back')}</div>
            </div>
          </div>
          <div className={classes.addcustomerContainer}>
            <AddCustomer setIsAddingPerson={setIsAddingPerson} />
          </div>
        </div>
      ) : isAddingOrder ? (
        <>
          {activeStep === 0 && (
            <>
              <ReportsTableHeader
                tabs={[]}
                firstNameSearch={nameSearch}
                setFirstNameSearch={setNameSearch}
                registerOnClick={() => setIsAddingPerson((state) => !state)}
              />
              <CustomPagination
                itemsPerPage={10}
                items={displayCustomers.sort((customerA, customerB) => {
                  if (customerA?.person_id && customerB?.person_id) {
                    return customerB.person_id - customerA.person_id;
                  }
                  return -1;
                })}
              >
                {(paginatedItems: any[]) => (
                  <ReportTable
                    columns={[
                      {
                        name: translations('first_name'),
                        path: 'person_firstname',
                        type: 'TEXT',
                      },
                      {
                        name: translations('last_name'),
                        path: 'person_lastname',
                        type: 'TEXT',
                      },
                      {
                        name: translations('date_of_birth'),
                        path: 'person_birthdate',
                        type: 'DATE',
                      },
                      {
                        name: translations('gender'),
                        path: 'gender',
                        type: 'TEXT',
                      },
                      {
                        name: translations('mobile'),
                        path: 'person_mobile_phone',
                        type: 'TEXT',
                      },
                      {
                        name: translations('email'),
                        path: 'person_email',
                        type: 'TEXT',
                      },
                    ]}
                    rows={paginatedItems}
                    actions={[
                      {
                        displayName: translations('view'),
                        onClick: (row) => {
                          setCustomerModal(row as ICustomer);
                        },
                      },
                      {
                        displayName: translations('select.customer'),
                        displayPrimaryButton: true,
                        onClick: (row) => {
                          setSelectedCustomer(row as ICustomer);
                          setActiveStep(1);
                        },
                      },
                    ]}
                  />
                )}
              </CustomPagination>
              {customerModal && (
                <CustomerView
                  isOpen={!!customerModal}
                  onClose={() => setCustomerModal(undefined)}
                  customer={customerModal}
                  onSelectCustomer={() => {
                    setSelectedCustomer(customerModal);
                    setActiveStep(1);
                    setCustomerModal(undefined);
                  }}
                />
              )}
            </>
          )}
          {activeStep > 0 && selectedCustomer && (
            <>
              <div className={classes.mainContainer}>
                <div>
                  <div className={classes.stepper}>
                    <Stepper
                      steps={
                        carts.length > 0 &&
                        carts[0].product?.product_group !== 'F' &&
                        carts[0].product?.product_group !== 'C'
                          ? [
                              { displayText: translations('select.customer').toString() },
                              { displayText: translations('add.product').toString() },
                              { displayText: translations('appointment').toString() },
                              // {
                              //   displayText: translations('laboratory.report.languages').toString(),
                              // },
                              { displayText: translations('button.book').toString() },
                            ]
                          : [
                              { displayText: translations('select.customer').toString() },
                              { displayText: translations('add.product').toString() },
                              { displayText: translations('appointment').toString() },
                              { displayText: translations('button.book').toString() },
                            ]
                      }
                      activeStep={activeStep}
                      setActiveStep={(val) => {
                        if (val < activeStep) {
                          setActiveStep(val);
                        }
                      }}
                    />
                  </div>
                  <div className={classes.paymentContainer}>
                    <div className={classes.sectionHeaderLabel}>
                      {translations('customer')}
                      <div className={classes.customerName}>
                        {selectedCustomer &&
                          `${selectedCustomer.person_firstname} ${selectedCustomer.person_lastname}`}
                      </div>
                    </div>
                    <div className={classes.orderContainer}>
                      <Cart />
                    </div>
                    <div className={classes.calculation}>
                      <div className={classes.cartContainer}>
                        <div
                          className={classes.clearCart}
                          onClick={() => {
                            dispatch(deleteCart());
                            toast.success(translations('cart.cleared'), {
                              position: POSITION.BOTTOM_RIGHT,
                            });
                          }}
                        >
                          {translations('clear.cart')}
                        </div>
                        <div className={classes.total}>
                          <p className={classes.totalPrice}>{translations('total')}</p>
                          <p>€ {(totalSum / 100).toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={classes.productsContainer}>
                  <div className={classes.sectionHeaderLabel}>{translations('products-')}</div>
                  <Products productGroups={productCategories} products={productDetails} />
                </div>
              </div>
              <div className={classes.orderButtonsContainer}>
                <PrimaryButtonV2
                  text={translations('button.book')}
                  disabled={
                    !selectedCustomer ||
                    !paymentMethods.includes('at_merchant') ||
                    carts.length === 0
                  }
                  containerStyle={{
                    marginRight: 10,
                  }}
                  buttonStyle={{
                    height: 60,
                    borderRadius: 6,
                    fontSize: '18px',
                    minWidth: 254,
                  }}
                  onClick={() => {
                    setIsConfirmPaymentModalOpen(true);
                    setActiveStep(totalSteps);
                  }}
                />
              </div>
            </>
          )}
          {showOrderSummaryModal && selectedCustomer && (
            <OrderSummaryModal
              isOpen={showOrderSummaryModal}
              onClose={() => {
                setShowOrderSummaryModal(false);
                setIsAddingOrder(false);
                dispatch(deleteCart());
                setSelectedCustomer(undefined);
                setSearchedCustomer(undefined);
              }}
              customer={selectedCustomer}
            />
          )}
        </>
      ) : (
        <>
          <div className={classes.customersContainer}>
            <ReportsTableHeader
              tabs={[]}
              firstNameSearch={customerFirstNameSearch}
              setFirstNameSearch={setCustomerFirstNameSearch}
              dateBegin={startDateValue}
              dateEnd={endDateValue}
              setDateBegin={setStartDateValue}
              setDateEnd={setEndDateValue}
              maxAppointmentDate={maxDate}
              showExportButton={true}
              dataToExport={displayOrders.map((data) => {
                return {
                  sales_order_id: data.sales_order_id,
                  external_id: data.sales_order_external_id,
                  customer_first_name: data.person_firstname,
                  customer_last_name: data.person_lastname,
                  total: data.amount_paid,
                  subtotal_amount: Number(
                    Number(Number(data.amount_paid) * (1 - Number(data.vat) / 100)).toFixed(2)
                  ),
                  voucher_amount: data.voucher_amount,
                  vat: data.vat,
                  currency: data.currency,
                  booking_date: moment(data.datetime_create).format('DD.MM.YYYY HH:mm').toString(),
                  appointment_date: moment(data.appointment_date)
                    .format('DD.MM.YYYY HH:mm')
                    .toString(),
                  payment_method: data.payment_method,
                  paid: data.paid,
                };
              })}
            />
            <CustomPagination itemsPerPage={10} items={sortedTransformedOrders}>
              {(paginatedItems: any[]) => (
                <div className={classes.tableContainer}>
                  <DataTable<IMappedSalesOrder, undefined, IMappedProductDetail>
                    rows={paginatedItems}
                    nestedRowsKey={'products'}
                    columns={[
                      {
                        displayName: translations('sales.order_id'),
                        renderer: (row) => (
                          <div className={classes.tableColumnID}>{row.sales_order_id}</div>
                        ),
                        align: 'center',
                      },
                      {
                        displayName: translations('external.id'),
                        renderer: (row) => row.sales_order_external_id,
                      },
                      {
                        displayName: translations('customer.first_name'),
                        renderer: (row) => row.person_firstname,
                      },
                      {
                        displayName: translations('customer.last_name'),
                        renderer: (row) => row.person_lastname,
                      },
                      {
                        displayName: translations('subtotal_amount'),
                        renderer: (row) => `€ ${row.items_subtotal}`,
                      },
                      {
                        displayName: translations('voucher_amount'),
                        renderer: (row) => row.voucher_amount,
                      },
                      {
                        displayName: translations('Vat'),
                        renderer: (row) => `€ ${row.vat}`,
                      },
                      {
                        displayName: translations('total'),
                        renderer: (row) => `€ ${row.paid_amount}`,
                      },
                      {
                        displayName: translations('currency.currency'),
                        renderer: (row) => row.currency,
                      },
                      {
                        displayName: `${translations('booking.date')}`,
                        renderer: (row) =>
                          format(parseISO(row.datetime_create.toString()), 'dd.MM.yyyy HH:mm'),
                        onSort: handleBookingDateSort,
                        sortOrder: bookingSortOrder,
                      },
                      {
                        displayName: translations('status'),
                        renderer: (row) => {
                          const salesOrderInfo = allSalesOrders.find(
                            (s) => s.sales_order.sales_order_id == row.sales_order_id
                          );
                          const status = salesOrderRecordStateToStatus(
                            row.record_state,
                            Boolean(
                              salesOrderInfo?.sales_order_appointment
                                ?.sales_order_appointment_status === 'M'
                            )
                          );
                          return (
                            <div className={classes.statusContainer}>
                              <div
                                className={getStatusClass(
                                  status.status,
                                  Boolean(
                                    salesOrderInfo?.sales_order_appointment
                                      ?.sales_order_appointment_status === 'M'
                                  )
                                )}
                              >
                                {translations(status.status)}
                              </div>
                            </div>
                          );
                        },
                      },
                      {
                        displayName: '',
                        renderer: (row) => (
                          <div
                            className={classes.tableActionButton}
                            onClick={() => {
                              const salesOrderRow = displayOrders.find(
                                (order) => order.sales_order_id === row.sales_order_id
                              );
                              if (salesOrderRow === undefined) {
                                return;
                              }
                              setSelectedOrder(salesOrderRow);
                              setOrderSummaryCartItems(
                                displayOrders
                                  .filter(
                                    (_order) =>
                                      _order.sales_order_id === salesOrderRow?.sales_order_id
                                  )
                                  .map((item) => {
                                    const salesOrderInfo = allSalesOrders.find(
                                      (s) =>
                                        s.sales_order.sales_order_id == item.sales_order_id &&
                                        s.sales_order_item.sales_order_item_id.toString() ==
                                          item.sales_order_item_id
                                    );
                                    return {
                                      name: item.product_name ?? '',
                                      quantity: 1,
                                      vat: item.vat,
                                      total: item.price
                                        ? parseFloat(item.price.toString() ?? 0)
                                        : 0,
                                      hasWorkOrder: salesOrderInfo?.work_order?.work_order_id
                                        ? true
                                        : false,
                                      isDiagnostic:
                                        salesOrderInfo?.service_service_group.service_group_id ==
                                          PHARMACY_DIAGNOSTICS_SERVICE_GROUP_ID ||
                                        salesOrderInfo?.service_service_group.service_group_id ==
                                          HOMECARE_DIAGNOSTICS_SERVICE_GROUP_ID,
                                      accountNumber:
                                        salesOrderInfo?.customer_person.person_account_number,
                                      salesOrderId: salesOrderInfo?.sales_order.sales_order_id,
                                      salesOrderItemId:
                                        salesOrderInfo?.sales_order_item.sales_order_item_id,
                                      salesOrderExternalId:
                                        salesOrderInfo?.sales_order.sales_order_external_id,
                                    };
                                  })
                              );
                              setShowOrderSummaryModal(true);
                              setSelectedCustomer(
                                customers.find(
                                  (c) => c.person_id === salesOrderRow.customer_person_id
                                )
                              );
                            }}
                          >
                            {translations('edit')}
                          </div>
                        ),
                      },
                    ]}
                    nestedColumns={[
                      {
                        displayName: '',
                        renderer: () => '',
                      },
                      {
                        displayName: translations('product.id'),
                        renderer: (row) => (
                          <div className={classes.productColumnID}>{row.product_id}</div>
                        ),
                        align: 'center',
                      },
                      {
                        displayName: translations('product.name'),
                        renderer: (row) => row.product_name,
                      },
                      {
                        displayName: translations('price'),
                        renderer: (row) =>
                          row.price ? `€ ${parseFloat(row.price.toString()).toFixed(2)}` : '-',
                      },
                      {
                        displayName: translations('appointment.date'),
                        renderer: (row) =>
                          row.start ? moment(row.start).format('DD.MM.YYYY HH:mm').toString() : '',
                      },
                      {
                        displayName: translations('status'),
                        renderer: (row) => {
                          const salesOrderInfo = allSalesOrders.find(
                            (s) => s.sales_order.sales_order_id == row.sales_order_id
                          );
                          const status = salesOrderRecordStateToStatus(
                            row.item_record_state,
                            Boolean(
                              salesOrderInfo?.sales_order_appointment
                                ?.sales_order_appointment_status === 'M'
                            )
                          );

                          return (
                            <div className={classes.statusContainer}>
                              <div
                                className={getStatusClass(
                                  status.status,
                                  Boolean(
                                    salesOrderInfo?.sales_order_appointment
                                      ?.sales_order_appointment_status === 'M'
                                  )
                                )}
                              >
                                {translations(status.status)}
                              </div>
                              {/* <div
                          className={classes.circleIcon}
                          style={{ backgroundColor: status.color }}
                        />
                        <div style={{ color: status.color }}>{translations(status.status)}</div> */}
                            </div>
                          );
                        },
                      },
                      {
                        displayName: '',
                        renderer: (row) => (
                          <div
                            className={classes.tableActionButton}
                            style={{
                              width: 40,
                            }}
                            onClick={() => {
                              const salesOrderRow = displayOrders.find(
                                (order) =>
                                  order.sales_order_id === row.sales_order_id &&
                                  order.sales_order_item_id == row.sales_order_item_id
                              );
                              if (salesOrderRow === undefined) {
                                return;
                              }
                              setSelectedOrder(salesOrderRow);
                              const salesOrderInfo = allSalesOrders.find(
                                (s) =>
                                  s.sales_order.sales_order_id == salesOrderRow.sales_order_id &&
                                  s.sales_order_item.sales_order_item_id.toString() ==
                                    salesOrderRow.sales_order_item_id
                              );
                              setOrderSummaryCartItems([
                                {
                                  name: row.product_name ?? '',
                                  quantity: 1,
                                  vat: salesOrderRow.vat,
                                  total: row.price ? parseFloat(row.price.toString() ?? 0) : 0,
                                  hasWorkOrder: salesOrderInfo?.work_order?.work_order_id
                                    ? true
                                    : false,
                                  isDiagnostic:
                                    salesOrderInfo?.service_service_group.service_group_id ==
                                      PHARMACY_DIAGNOSTICS_SERVICE_GROUP_ID ||
                                    salesOrderInfo?.service_service_group.service_group_id ==
                                      HOMECARE_DIAGNOSTICS_SERVICE_GROUP_ID,
                                  accountNumber:
                                    salesOrderInfo?.customer_person.person_account_number,
                                  salesOrderId: salesOrderInfo?.sales_order.sales_order_id,
                                  salesOrderItemId:
                                    salesOrderInfo?.sales_order_item.sales_order_item_id,
                                  salesOrderExternalId:
                                    salesOrderInfo?.sales_order.sales_order_external_id,
                                },
                              ]);
                              setShowOrderSummaryModal(true);
                              setSelectedCustomer(
                                customers.find(
                                  (c) => c.person_id === salesOrderRow.customer_person_id
                                )
                              );
                            }}
                          >
                            {translations('edit')}
                          </div>
                        ),
                      },
                      {
                        displayName: '',
                        renderer: () => '',
                      },
                      {
                        displayName: '',
                        renderer: () => '',
                      },
                      {
                        displayName: '',
                        renderer: () => '',
                      },
                      {
                        displayName: '',
                        renderer: () => '',
                      },
                      {
                        displayName: '',
                        renderer: () => '',
                      },
                      {
                        displayName: '',
                        renderer: () => '',
                      },
                    ]}
                    expandedRows={expandedRows}
                    onExpandClick={(index) => {
                      if (expandedRows.includes(index)) {
                        setExpandedRows(expandedRows.filter((exR) => exR !== index));
                        return;
                      }
                      setExpandedRows([...expandedRows, index]);
                    }}
                  />
                </div>
              )}
            </CustomPagination>
          </div>
          {showOrderSummaryModal && selectedCustomer && (
            <OrderSummaryModal
              isOpen={showOrderSummaryModal}
              onClose={() => {
                setShowOrderSummaryModal(false);
                setIsAddingOrder(false);
                dispatch(deleteCart());
                setSelectedCustomer(undefined);
                setSearchedCustomer(undefined);
              }}
              customer={selectedCustomer}
              cartItems={orderSummaryCartItems}
              salesOrder={selectedOrder}
            />
          )}
        </>
      )}
      {searchedCustomer && (
        <SelectCustomerModal
          isOpen={isSelectCustomerModalOpen}
          onClose={() => setIsSelectCustomerModalOpen(false)}
          customer={searchedCustomer}
          onBookTestWithCustomer={() => {
            setSelectedCustomer(searchedCustomer);
            setIsSelectCustomerModalOpen(false);
          }}
        />
      )}
      <PayInvoiceModal
        isOpen={isPayInvoiceModalOpen}
        onClose={() => setIsPayInvoiceModalOpen(false)}
        productId={carts.length > 0 ? carts[0].product?.product_id : 0}
        customerEmail={selectedCustomer?.person_email ?? ''}
        resetCustomerAndProduct={() => {
          setSelectedCustomer(undefined);
          dispatch(deleteCart());
        }}
      />
      <ConfirmPaymentModal
        isOpen={isConfirmPaymentModalOpen}
        onClose={() => {
          setIsConfirmPaymentModalOpen(false);
          setActiveStep(totalSteps - 1);
        }}
        productPrice={totalSum}
        confirmPayment={onSaveSalesOrderProduct}
        isLoading={isSpinnerActive}
      />
      {isScanningQrCode && (
        <QrCodeModal
          isOpen={isScanningQrCode}
          onClose={() => setIsScanningQrCode(false)}
          onSuccessScan={(decodedText: string) => {
            let a = decodedText.split('\r\n');
            let longestString = '';
            for (let i = 0; i < a.length; i++) {
              if (a[i].trim().includes('DE') && a[i].trim().length >= 20)
                longestString = a[i].trim();
            }
            if (longestString && longestString.length >= 10) {
              let accountNumber: string = longestString.slice(-10);
              onScanCustomer(accountNumber);
            }
            setIsScanningQrCode(false);
          }}
        />
      )}
    </div>
  );
};

export default Order;
